import axios from "axios";

const isProd = process.env.NODE_ENV == "production";

axios.defaults.baseURL = isProd
  ? process.env.VUE_APP_PARSE_PROD_URL.replace("/parse", "")
  : "https://happy.test.jadeh.co";

export default axios;
